<template>
  <div class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <h2>{{ message }}</h2>
      <div class="button-group">
        <button
          v-for="(button, index) in buttonsConfig"
          :key="index"
          @click="handleButtonClick(button)"
          :class="['p-button', button.class]"
        >
          {{ button.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmComponent",
  props: {
    message: {
      type: String,
      required: true,
    },
    dinamicValue: {
      type: String,
      required: false,
    },
  },
  computed: {
    buttonsConfig() {
      // Define your static configurations keyed by a "base" string
      const config = {
        "Que operação deseja realizar?": [
          {
            label: "Interromper",
            event: "confirm",
            closeAfter: false,
            class: "p-confirm-popup-accept",
          },
          {
            label: "Remarcar",
            event: "remark",
            closeAfter: false,
            class: "p-confirm-popup-reject",
          },
        ],
        "Deseja rejeitar equipamento de ?": [
          {
            label: "Confirmar",
            event: "rejeitar",
            closeAfter: true,
            class: "p-confirm-popup-accept",
          },
          {
            label: "Cancelar",
            event: "cancel",
            closeAfter: false,
            class: "p-confirm-popup-reject",
          },
        ],
        "Deseja fechar o serviço de ?": [
          {
            label: "Confirmar",
            event: "fechar",
            closeAfter: true,
            class: "p-confirm-popup-accept",
          },
          {
            label: "Cancelar",
            event: "cancel",
            closeAfter: false,
            class: "p-confirm-popup-reject",
          },
        ],
        "Quer começar este serviço?": [
          {
            label: "Confirmar",
            event: "confirm",
            closeAfter: false,
            class: "p-confirm-popup-accept",
          },
          {
            label: "Cancelar",
            event: "cancel",
            closeAfter: false,
            class: "p-confirm-popup-reject",
          },
        ],
        "Quer continuar este serviço?": [
          {
            label: "Confirmar",
            event: "confirm",
            closeAfter: false,
            class: "p-confirm-popup-accept",
          },
          {
            label: "Cancelar",
            event: "cancel",
            closeAfter: false,
            class: "p-confirm-popup-reject",
          },
        ],
        "Deseja entrar neste serviço?": [
          {
            label: "Confirmar",
            event: "confirm",
            closeAfter: false,
            class: "p-confirm-popup-accept",
          },
          {
            label: "Cancelar",
            event: "cancel",
            closeAfter: false,
            class: "p-confirm-popup-reject",
          },
        ],
        "Deseja substituir este artigo?": [
          {
            label: "Confirmar",
            event: "substituir",
            closeAfter: true,
            class: "p-confirm-popup-accept",
          },
          {
            label: "Só Rejeitar",
            event: "so-rejeitar",
            closeAfter: true,
            class: "p-confirm-popup-reject",
          },
        ],
        "Deseja recolher o artigo?": [
          {
            label: "Confirmar",
            event: "recolher",
            closeAfter: true,
            class: "p-confirm-popup-accept",
          },
          {
            label: "Só Rejeitar",
            event: "so-rejeitar",
            closeAfter: true,
            class: "p-confirm-popup-reject",
          },
        ],
      };

      // Check for the dynamic cases using the known prefixes.
      if (
        this.message.startsWith("Deseja rejeitar equipamento de") &&
        this.message.endsWith("?")
      ) {
        return config["Deseja rejeitar equipamento de ?"];
      }
      if (
        this.message.startsWith("Deseja fechar o serviço de") &&
        this.message.endsWith("?")
      ) {
        return config["Deseja fechar o serviço de ?"];
      }
      if (
        this.message.startsWith("Deseja recolher o artigo") &&
        this.message.endsWith("?")
      ) {
        return config["Deseja recolher o artigo?"];
      }
      // For other messages, try an exact match
      return config[this.message] || [];
    },
  },
  methods: {
    handleButtonClick(button) {
      // Emit the event specified in the button configuration.
      this.$emit(button.event);
      // If the button should close the modal after the event, do so.
      if (button.closeAfter) {
        this.closeModal();
      }
    },
    closeModal() {
      this.$emit("cancel");
    },
  },
  
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: #626288;
  color: white;
  border: 0 none;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14),
    0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

.modal-content button {
  margin: 10px;
  font-size: 14px;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
}

.p-confirm-popup-reject {
  background-color: rgba(255, 0, 0, 0.792);
  color: white;
}

.p-confirm-popup-accept {
  background-color: rgb(255, 155, 5);
  color: white;
}
</style>
